import React, { useState, useRef, useEffect } from 'react';
import {
  Badge, Button, Form, Modal, Table, Alert,
} from 'react-bootstrap';
import { Navbar } from '../../../components/Navbar';
import { Sidebar } from '../../../components/Sidebar';
import useIndicacoesConfiguracoes from '../../../services/api/indicacoesConfiguracoes';

const emptyForm = {
  nome: '', descricao: '', ativo: true,
};

export default function IndicacoesConfiguracoes() {
  // ✅ estado apenas para "salvar" (create/edit)
  const [submitting, setSubmitting] = useState(false);

  const normalizeMsg = (msg) => {
    if (!msg) return '';
    if (typeof msg === 'string') return msg;
    if (typeof msg?.message === 'string') return msg.message;
    if (typeof msg?.mensagem === 'string') return msg.mensagem;
    try { return JSON.stringify(msg); } catch { return String(msg); }
  };

  // ✅ Float Alert (auto close) - igual ao exemplo
  const [floatAlert, setFloatAlert] = useState({
    isVisible: false,
    message: '',
    variant: 'success',
  });

  const floatTimerRef = useRef(null);

  const showFloatAlert = (message, variant = 'success') => {
    if (floatTimerRef.current) clearTimeout(floatTimerRef.current);

    setFloatAlert({ isVisible: true, message: normalizeMsg(message), variant });
    floatTimerRef.current = setTimeout(() => {
      setFloatAlert({ isVisible: false, message: '', variant: 'success' });
      floatTimerRef.current = null;
    }, 3000);
  };

  useEffect(() => () => {
    if (floatTimerRef.current) clearTimeout(floatTimerRef.current);
  }, []);

  // Modal (criar/editar)
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState('create'); // create | edit
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyForm);

  // Acesso já é gated na rota (routesAdm.jsx, requiresPermissao=
  // "configuracoes.indicacoes") - não repetir a checagem aqui, senão quem
  // ganhar a permissão por um setor fora de Gestão fica preso de novo.

  // ✅ SWR (lista)
  const {
    indicacoes,
    isLoading,
    isError,
    criarIndicacao,
    editarIndicacao,
  } = useIndicacoesConfiguracoes();

  // ✅ trava UI quando carregando lista ou salvando
  const isBusy = submitting || isLoading;

  const openCreate = () => {
    setMode('create');
    setEditingId(null);
    setForm(emptyForm);
    setShow(true);
  };

  const openEdit = (o) => {
    setMode('edit');
    setEditingId(o.id);
    setForm({
      nome: o.nome || '',
      descricao: o.descricao || '',
      ativo: !!o.ativo,
    });
    setShow(true);
  };

  const validate = () => {
    if (!form.nome.trim()) return 'Informe o nome.';
    return null;
  };

  const save = async () => {
    const err = validate();
    if (err) {
      showFloatAlert(err, 'danger');
      return;
    }

    const payload = {
      nome: form.nome.trim().toUpperCase(),
      descricao: form.descricao?.trim() || null,
      ativo: !!form.ativo,
    };

    setSubmitting(true);
    try {
      if (mode === 'create') {
        await criarIndicacao(payload);
      } else {
        await editarIndicacao(editingId, payload);
      }

      setShow(false);
      setEditingId(null);
      setForm(emptyForm);
      showFloatAlert('Dados salvos com sucesso!', 'success');
    } catch (e) {
      console.error('Erro ao salvar indicação:', e);

      const status = e?.response?.status;
      const apiMsg = e?.response?.data?.mensagem
    || e?.response?.data?.message
    || e?.response?.data?.error;

      const msg = apiMsg
    || (status ? `Falha ao salvar (HTTP ${status}).` : null)
    || e?.message
    || 'Não foi possível salvar a indicação.';

      showFloatAlert(msg, 'danger');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* ✅ FLOAT ALERT - top */}
      {floatAlert.isVisible && (
      <div className="fixed-top mt-5" style={{ zIndex: 3000 }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-6">
              <Alert
                variant={floatAlert.variant}
                onClose={() => setFloatAlert({ isVisible: false, message: '', variant: 'success' })}
                dismissible
              >
                <p className="text-center mt-3">{floatAlert.message}</p>
              </Alert>
            </div>
          </div>
        </div>
      </div>
      )}

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            <div className="container-fluid">
              <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Indicações - Configurações</h1>

                <Button variant="success" onClick={openCreate} disabled={isBusy}>
                  Criar nova indicação
                </Button>
              </div>

              <hr />

              <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <strong className="m-0">Lista de indicações</strong>
                </div>

                <div className="card-body">
                  <Table responsive size="sm" className="mb-0 align-middle">
                    <thead>
                      <tr>
                        <th style={{ width: '30%' }}>Nome</th>
                        <th>Descrição</th>
                        <th style={{ width: '14%' }} className="text-center">
                          Ativo
                        </th>
                        <th style={{ width: '16%' }} className="text-center">
                          Ações
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan={4} className="text-center text-muted py-4">
                            Carregando...
                          </td>
                        </tr>
                      ) : isError ? (
                        <tr>
                          <td colSpan={4} className="text-center text-danger py-4">
                            Erro ao carregar indicações.
                          </td>
                        </tr>
                      ) : (indicacoes || []).length === 0 ? (
                        <tr>
                          <td colSpan={4} className="text-center text-muted py-4">
                            Nenhuma indicação cadastrada.
                          </td>
                        </tr>
                      ) : (
                        indicacoes.map((o) => (
                          <tr key={o.id}>
                            {/* ✅ MAIÚSCULO e sem negrito */}
                            <td>{String(o.nome || '').toUpperCase()}</td>

                            <td className="text-muted">{o.descricao || '-'}</td>

                            <td className="text-center">
                              <Badge bg={o.ativo ? 'success' : 'secondary'}>
                                {o.ativo ? 'Ativo' : 'Inativo'}
                              </Badge>
                            </td>

                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-2">
                                <Button
                                  size="sm"
                                  variant="secondary"
                                  onClick={() => openEdit(o)}
                                  disabled={isBusy}
                                >
                                  Editar
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>

              {/* ✅ MODAL (Criar/Editar) padrão do exemplo */}
              <Modal
                show={show}
                onHide={() => {
                  if (isBusy) return;
                  setShow(false);
                  setEditingId(null);
                  setForm(emptyForm);
                }}
                centered
              >
                <Modal.Header closeButton={!isBusy}>
                  <Modal.Title>
                    {mode === 'create' ? 'Criar nova indicação' : 'Editar indicação'}
                  </Modal.Title>
                </Modal.Header>

                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (isBusy) return;
                    save();
                  }}
                >
                  <Modal.Body>
                    <div className="mb-3">
                      <Form.Label className="fw-semibold">Nome:</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Ex: Indicação por Email"
                        value={form.nome}
                        onChange={(e) => setForm((prev) => ({
                          ...prev,
                          nome: e.target.value.toUpperCase(),
                        }))}
                        maxLength={80}
                        disabled={isBusy}
                      />
                    </div>

                    <div className="mb-3">
                      <Form.Label className="fw-semibold">Descrição:</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Ex: Indicação recebida via email"
                        value={form.descricao}
                        onChange={(e) => setForm((prev) => ({
                          ...prev,
                          descricao: e.target.value,
                        }))}
                        maxLength={200}
                        disabled={isBusy}
                      />
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="outline-secondary"
                      type="button"
                      onClick={() => {
                        if (isBusy) return;
                        setShow(false);
                        setEditingId(null);
                        setForm(emptyForm);
                      }}
                      disabled={isBusy}
                    >
                      Cancelar
                    </Button>

                    <Button variant="primary" type="submit" disabled={isBusy}>
                      {submitting ? 'Salvando...' : 'Salvar'}
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
